var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.58172 4.08172 0 8.5 0H63.5C67.9183 0 71.5 3.58172 71.5 8V44C71.5 48.4183 67.9183 52 63.5 52H8.5C4.08172 52 0.5 48.4183 0.5 44V8Z",
    fill: "#FFE1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5157 34V29.828H10.0237L9.68766 27.112L18.8157 14.764H22.9877V26.832H25.6477V29.828H22.9877V34H19.5157ZM13.4117 26.832H19.5157V18.572L13.4117 26.832ZM36.5858 34.336C31.6298 34.336 28.1298 30.22 28.1298 24.368C28.1298 18.544 31.6298 14.428 36.5858 14.428C41.5138 14.428 44.9858 18.544 44.9858 24.368C44.9858 30.22 41.5138 34.336 36.5858 34.336ZM36.5858 31.144C39.4138 31.144 41.4298 28.344 41.4298 24.368C41.4298 20.392 39.4138 17.62 36.5858 17.62C33.7298 17.62 31.7138 20.392 31.7138 24.368C31.7138 28.344 33.7298 31.144 36.5858 31.144ZM54.7346 34.336C51.3746 34.336 48.7986 32.964 47.2306 31.088L49.3586 28.792C50.7026 30.304 52.5506 31.228 54.6226 31.228C56.9186 31.228 58.3466 30.08 58.3466 28.4C58.3466 26.692 56.9186 25.796 54.2026 25.796L52.0466 25.824V22.8H54.2026C56.4706 22.828 57.9546 21.904 57.9546 20.224C57.9546 18.656 56.4426 17.564 54.3706 17.564C52.4666 17.564 51.0106 18.488 49.6946 19.944L47.6226 17.816C49.1626 15.884 51.4026 14.428 54.6786 14.428C58.7666 14.428 61.4826 16.612 61.4826 19.664C61.4826 21.988 59.9146 23.5 57.8426 24.116C59.8866 24.592 61.9026 26.076 61.9026 28.68C61.9026 31.984 59.0746 34.336 54.7346 34.336Z",
    fill: "#BF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorised);
export default __webpack_public_path__ + "static/media/unauthorised.7c43e769a097158152c8f1a3e068b46e.svg";
export { ForwardRef as ReactComponent };